module.exports = {
  StartEndDateCannotEmpty: 'Ngày bắt đầu hoặc ngày kết thúc không được để trống!',
  StartBeEarlierThanDate: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
  Continent: 'Châu lục',
  Route: 'Tuyến đường',
  Network: 'Mạng lưới',
  Currency: 'Loại tiền tệ',
  ContainerType: 'Loại container',
  Package: 'Bao bì',
  BillOfLadingType: 'Loại vận đơn',
  CargoType: 'Loại hàng hóa',
  TradeTerms: 'Điều khoản thương mại',
  TransportationTerms: 'Điều khoản vận chuyển',
  FreightTerms: 'Điều khoản cước phí',
  TradeMethod: 'Phương thức thương mại',
  CustomsDeclarationMethod: 'Phương thức khai báo hải quan',
  AirFreightServiceItem: 'Dịch vụ cước phí hàng không',
  RelatedPort: 'Cảng liên quan',
  AirWaybillSundryCharge: 'Phụ phí vận đơn hàng không',
  ClientType: 'Loại khách hàng',
  AppraisalCategory: 'Loại giám định',
  ShippingDocumentMethod: 'Phương thức vận đơn',
  CustomBusinessType: 'Loại nghiệp vụ tùy chỉnh',
  TransitDocumentType: 'Loại tài liệu lưu chuyển',
  CommissionRule: 'Quy tắc hoa hồng',
  RailwayLine: 'Tuyến đường sắt',
  ValueAddedService: 'Dịch vụ gia tăng',
  BilledUnitUnit: 'Đơn vị tính phí/Đơn vị',
  HazardousGoods: 'Hàng nguy hiểm',
  CargoInformation: 'Thông tin hàng hóa',
  LiabilityReason: 'Nguyên nhân xác định trách nhiệm',
  ClientSource: 'Nguồn khách hàng',
  MultimodalTransportType: 'Loại hình vận tải tổng hợp',
  VehicleType: 'Loại xe',
  CustomEqType: 'Loại container tùy chỉnh',
  CollaborativeBusinessType: 'Loại nghiệp vụ hợp tác',
  Records: 'điều;',
  recordsImportedToTheSystem: '@records đã nhập thành công vào hệ thống!',
  Records2: 'điều',
  Edit: 'Chỉnh sửa',
  Delete: 'Xóa',
  Disable: 'Ngừng sử dụng',
  Enable: 'Kích hoạt',
  AreWantToDeleteRecord: 'Bạn có chắc chắn muốn xóa bản ghi này không?',
  Reminder: 'Thông báo',
  Confirm: 'Xác nhận',
  Cancel: 'Hủy',
  SuccessfullyDeleted: 'Xóa thành công!',
  DeletionCanceled: 'Đã hủy xóa',
  DoToOverwriteExistingData: 'Có ghi đè dữ liệu hiện có không',
  Overwrite: 'Ghi đè',
  PleaseSelectDataToExport: 'Vui lòng chọn dữ liệu bạn muốn xuất.',
  UploadedBeXlsOrFormat: 'Tệp tải lên chỉ có thể là định dạng xls hoặc xlsx!',
  FileSizeCannotExceed2MB: 'Kích thước tệp không được vượt quá 2MB.',
  ImportPleaseContactTheAdministrator: 'Nhập thất bại, vui lòng liên hệ quản trị viên.',
  DataExistingDataInTable: 'Dữ liệu bị trùng với dữ liệu đã có trong bảng!',
  SuccessfullyAdded: 'Thêm thành công.',
  City: 'Thành phố.',
  BusinessType: 'Loại hình nghiệp vụ.',
  PlatformCustomerService: 'Hỗ trợ khách hàng nền tảng.',
  Code: 'Mã.',
  Name: 'Tên.',
  ChineseName: 'Tên tiếng Trung.',
  EnglishName: 'Tên tiếng Anh.',
  ChineseName2: 'Tên gọi tiếng Trung.',
  FeeDetailsXls: 'Chi tiết chi phí.xls.',
  UnitedNationsNumberAlreadyExists: 'Số liên hợp quốc đã tồn tại.',
  UserCannotBeEmpty: 'Người dùng không được để trống.',
  Yes: 'Có.',
  No: 'Không.',
  MergeInProgressPleaseWait: 'Đang hợp nhất, vui lòng chờ.',
  YouExpectedToCompleteLater: 'Bạn có thể rời khỏi giao diện này, dự kiến hợp nhất sẽ hoàn tất trong vòng 10 phút, vui lòng kiểm tra sau.',
  Note: 'Nhắc nhở.',
  Success: 'Thao tác thành công.',
  ChineseNameCannotBeEmpty: 'Tên tiếng Trung không được để trống.',
  EmailFormatError: 'Định dạng email sai.',
  ApplicableOrderRulescombinedName: 'Tên quy tắc phát hành đơn áp dụng (tổ hợp).',
  OnlyCanBeSetPort: 'Chỉ có thể thiết lập một đại lý hàng hóa mặc định cho cùng một cảng đích.',
  UserCannotBeEmpty2: 'Người dùng không được để trống!',
  DataIsIncorrectPleaseCheck: 'Dữ liệu không đúng, vui lòng kiểm tra lại!',
  PleaseNumberYouWantDelete: 'Vui lòng chọn số ước bạn muốn xóa!',
  PleaseSelectABranch: 'Vui lòng chọn chi nhánh!',
  SiteNotSelected: 'Trạm chưa được chọn.',
  AlreadyAddedCannotAddRepeatedly: 'Đã thêm, không thể thêm lặp lại!',
  AddedSuccessfully: 'Thêm thành công.',
  SavedLibraryAlreadyExistsSave: 'Lưu thành công, các từ nhạy cảm sau đã tồn tại trong kho từ, không cần lưu:',
  SavedWordsHaveBeenTimes: 'Lưu thành công, các từ nhạy cảm sau đã được nhập nhiều lần:',
  TheHaveBeenEnteredTimes: 'Các từ nhạy cảm sau đã được nhập nhiều lần:',
  FieldName: 'Tên trường.',
  SensitiveWords: 'Từ nhạy cảm.',
  Threshold: 'Ngưỡng từ nhạy cảm.',
  ThresholdTip: 'Ngưỡng từ nhạy cảm biểu thị số bit mờ của từ nhạy cảm, 0 đại diện cho kiểm tra khớp 100%.',
  EditedSuccessfully: 'Chỉnh sửa thành công.',
  ChineseProductName: 'Tên hàng tiếng Trung.',
  EnglishProductName: 'Tên hàng tiếng Anh.',
  ShippingMarks: 'Ký hiệu.',
  EmailRemindertestOnly: 'Nhắc nhở email (dành cho kiểm thử).',
  SplitDataBecomesNewData: 'Tách (dữ liệu cũ thành dữ liệu mới).',
  SplittingDataAreYouSplit: 'Sau khi tách sẽ xóa dữ liệu gốc, xác nhận tách?',
  SplitSuccessfullySplitInto: 'Tách thành công, đã tách thành.',
  SensitiveWordManagement: 'Quản lý từ nhạy cảm.',
  CodeCannotBeEmpty: 'Mã không được để trống.',
  EnglishNameCannotBeEmpty: 'Tên tiếng Anh không được để trống.',
  ContractConfiguration: 'Cấu hình hợp đồng',
  NoteTheReminderMethodIs: 'Lưu ý: Phương thức nhắc nhở là',
  ReminderConfiguration: 'Cấu hình nhắc nhở:',
  ReminderRemaining: 'Còn lại trước ngày hết hạn',
  DaysBeforeTheDueDate: 'ngày nhắc nhở',
  ReminderUser: 'Nhắc nhở người dùng:',
  ContractAdministrator: 'Quản lý hợp đồng',
  Sales: 'Bán hàng',
  ProhibitionOfCreatingBusinessConfiguration: 'Cấm tạo cấu hình nghiệp vụ:',
  ContractAbleToCreateExpiration: 'Sau khi hợp đồng hết hạn sẽ không thể tạo nghiệp vụ',
  SavedSuccessfully: 'Lưu thành công',
  CustomerLevel: 'Cấp độ khách hàng',
  ContractStatus: 'Trạng thái hợp đồng',
  ContractType: 'Loại hợp đồng',
  ExtensionCycle: 'Chu kỳ gia hạn',
  Partner: 'Đối tác',
  ContractNumber: 'Số hợp đồng',
  EffectiveDate: 'Ngày hiệu lực',
  ExpirationDate: 'Ngày hết hạn',
  ContractAgreement: 'Thỏa thuận hợp đồng',
  CustomerContract: 'Hợp đồng khách hàng',
  SupplierContract: 'Hợp đồng nhà cung cấp',
  OverseasAgentContract: 'Hợp đồng đại lý nước ngoài',
  OtherContracts: 'Hợp đồng khác',
  ContractTerms: 'Điều khoản hợp đồng',
  DeferredAfterExpiration: 'Gia hạn sau khi hết hạn',
  N1Year: '1 năm',
  N2Years: '2 năm',
  N3Years: '3 năm',
  Other: 'Khác',
  OneClickRenewal: 'Gia hạn một lần',
  Close: 'Đóng',
  AddContract: 'Thêm hợp đồng mới',
  EditContract: 'Chỉnh sửa hợp đồng',
  RenewContract: 'Gia hạn hợp đồng',
  ViewContract: 'Xem hợp đồng',
  Contract: 'Hợp đồng',
  PartnerCannotBeEmpty: 'Đối tác không được để trống.',
  ContractNumberCannotBeEmpty: 'Số hợp đồng không được để trống.',
  EffectiveDateCannotBeEmpty: 'Ngày hiệu lực không được để trống.',
  ExpirationDateCannotBeEmpty: 'Ngày hết hạn không được để trống.',
  ContractAgreementCannotBeEmpty: 'Thỏa thuận hợp đồng không được để trống.',
  unSupportContractCurrency: 'Không tìm thấy tỷ giá trực tiếp hoặc gián tiếp để chuyển đổi "{0}" sang "{1}", vui lòng cập nhật tỷ giá liên quan kịp thời.',
  QuickSearchContractNumber: 'Tìm kiếm nhanh: Số hợp đồng',
  LogRecord: 'Nhật ký hoạt động',
  Add: 'Thêm mới',
  HintSetToExpireDays: 'Nhắc nhở: Hệ thống sẽ đánh dấu là sắp hết hạn trong vòng 30 ngày',
  OperationType: 'Loại thao tác',
  Operator: 'Người thao tác',
  Time: 'Thời gian',
  EditField: 'Trường chỉnh sửa',
  OriginalValue: 'Giá trị gốc',
  NewValue: 'Giá trị mới',
  AuditStatus: 'Trạng thái phê duyệt',
  OperationDate: 'Ngày thao tác',
  SettlementType: 'Loại thanh toán',
  SettlementMethod: 'Phương thức thanh toán',
  Limit: 'Hạn mức',
  LimitCurrency: 'Loại tiền hạn mức',
  DateType: 'Loại ngày',
  BillingCycle: 'Chu kỳ kế toán',
  WhetherToPostpone: 'Có gia hạn không',
  PostponementCycle: 'Chu kỳ gia hạn',
  WhetherChapterHasBeenUploaded: 'Đã tải lên chữ ký đặt chỗ chưa',
  WhetherAgreementHasBeenUploaded: 'Đã tải lên hợp đồng chưa',
  Operation: 'Thao tác',
  Renewal: 'Gia hạn',
  Revoke: 'Hủy bỏ',
  TheAndTheOperationAllowed: 'Hợp đồng đã gia hạn, không được thao tác',
  DoYouNeedToUpdate: 'Có cần cập nhật không',
  ContractCreator: 'Người tạo hợp đồng',
  ContractCreationTime: 'Thời gian tạo hợp đồng',
  PartnerCreator: 'Người tạo đối tác',
  ContractAuditor: 'Người phê duyệt hợp đồng',
  ContractAuditTime: 'Thời gian phê duyệt hợp đồng',
  PleaseSelectContractRecord: 'Vui lòng chọn bản ghi hợp đồng.',
  ContractRecordIsEmpty: 'Bản ghi hợp đồng trống.',
  ContractRevocationSuccessful: 'Hủy hợp đồng thành công.',
  QuickSearch: 'Tìm kiếm nhanh:',
  BulkRejection: 'Từ chối hàng loạt',
  All: 'Tất cả',
  Unaudited: 'Chưa phê duyệt',
  Submitted: 'Đã nộp',
  Audited: 'Đã phê duyệt',
  PleaseSelectData: 'Vui lòng chọn dữ liệu.',
  OnlySchemesWithAuditUnreviewed: 'Chỉ được chọn phương án chi phí ở trạng thái chưa nộp.',
  OnlySchemesWithAuditReviewed: 'Chỉ được chọn phương án chi phí ở trạng thái đã phê duyệt.',
  OnlySchemesWithAuditSubmitted: 'Chỉ được chọn phương án chi phí ở trạng thái đã nộp.',
  OnlyGuaranteeWithAuditUnreviewed: 'Chỉ được chọn bảo lãnh ở trạng thái chưa nộp.',
  OnlyGuaranteeWithAuditReviewed: 'Chỉ được chọn bảo lãnh ở trạng thái đã phê duyệt.',
  OnlyGuaranteeWithAuditSubmitted: 'Chỉ được chọn bảo lãnh ở trạng thái đã nộp.',
  GuaranteeFileIsNull: 'Tệp bảo lãnh đều trống',
  SelectGuaranteeFileIsNull: '{0} chưa tải lên tệp bảo lãnh',
  CodeDuplicatedPleaseReEnter: 'Mã bị trùng, vui lòng nhập lại.',
  Country: 'Quốc gia',
  CannotEditMultipleSchemes: 'Không thể chỉnh sửa nhiều phương án.',
  CannotCopyMultipleSchemes: 'Không thể sao chép nhiều phương án.',
  DeletedSuccessfully: 'Xóa thành công',
  PleaseEnterTheSchemeName: 'Vui lòng nhập tên phương án',
  PleaseEnterTheStartingRow: 'Vui lòng nhập dòng bắt đầu',
  PleaseTheExcelCellName: 'Vui lòng điền tên ô Excel',
  PleaseEnterTheSpaceProportion: 'Vui lòng nhập tỷ lệ khoảng trắng',
  EnglishName2: 'Tên tiếng Anh',
  UnknownType: 'Loại không xác định',
  SeaExport: 'Xuất khẩu đường biển',
  AirExport: 'Xuất khẩu đường hàng không',
  BusinessTypeCannotBeEmpty: 'Loại nghiệp vụ không được để trống.',
  OperationTypeCannotBeEmpty: 'Loại yêu cầu thao tác không được để trống.',
  ContentDescriptionCannotBeEmpty: 'Mô tả nội dung không được để trống.',
  OverseasWarehouse: 'Kho nước ngoài',
  PartnerInformationImport: 'Nhập thông tin đối tác',
  PleaseSelectTemplateType: 'Vui lòng chọn loại mẫu',
  PleaseSelectImportType: 'Vui lòng chọn loại nhập',
  ImportTime: 'Thời gian nhập',
  SelectDate: 'Chọn ngày',
  ImportResult: 'Kết quả nhập',
  PleaseSelect: 'Vui lòng chọn',
  ImportType: 'Loại nhập',
  ImportSuccessful: 'Nhập thành công',
  DownloadTemplate: 'Tải mẫu',
  PartnerBasicInformation: 'Thông tin cơ bản đối tác',
  PartnerBillingHeaderInformation: 'Thông tin hóa đơn đối tác',
  Download: 'Tải xuống',
  ImportFile: 'Nhập file',
  SelectFile: 'Chọn file',
  ConfirmImport: 'Xác nhận nhập',
  ReminderPartnerBasicInformationFirst: 'Nhắc nhở: Vui lòng nhập thông tin cơ bản đối tác trước',
  Search: 'Tìm kiếm',
  To: 'đến',
  ContinueImport: 'Tiếp tục nhập',
  EnterPartnerInformation: 'Vào đối tác',
  DownloadImportResult: 'Tải kết quả nhập',
  ViewFile: 'Xem file',
  SerialNumber: 'Số serial',
  LogFile: 'File nhật ký',
  RemarkDescription: 'Ghi chú',
  AllSuccessful: 'Tất cả thành công',
  AllFailed: 'Tất cả thất bại',
  PartiallySuccessfulPartiallyFailed: 'Một phần thành công, một phần thất bại',
  TheOnlyBeXlsFormat: 'File tải lên chỉ có thể là định dạng xls, xlsx!',
  ConfirmDeletionOfTheSite: 'Xác nhận xóa trạm?',
  TheByTheBusinessDeleted: 'Các trạm sau đã được sử dụng, không được phép xóa!',
  RailwayStation: 'Trạm đường sắt',
  WhetherToOverwriteExistingData: 'Có ghi đè dữ liệu hiện có không',
  PleaseDataYouWantExport: 'Vui lòng chọn dữ liệu cần xuất.',
  FileBeLargerThan2MB: 'Kích thước file không được lớn hơn 2MB',
  Items: 'dòng;',
  recordsImportedIntoTheSystem: '@records bản ghi đã nhập thành công vào hệ thống!',
  Items2: 'điều',
  PortOfLoadingPOL: 'Cảng xếp hàng (POL)',
  PortOfDischargePOD: 'Cảng dỡ hàng (POD)',
  PlaceOfDelivery: 'Địa điểm giao hàng',
  ShippingCompany: 'Công ty tàu biển',
  DestinationPortAgent: 'Đại lý cảng đích',
  ShippingRoute: 'Tuyến đường',
  DisplayRules: 'Quy tắc hiển thị',
  OperationalRequirements: 'Yêu cầu thao tác',
  PleaseEnterTheContent: 'Vui lòng nhập nội dung',
  AttachmentDescription: 'Mô tả tệp đính kèm',
  ViewAttachment: 'Xem tệp đính kèm',
  WhetherToUseForMBL: 'Có dùng cho MBL không?',
  WhetherToUseForHBL: 'Có dùng cho HBL không?',
  AddPortRequirementsseaPort: 'Thêm yêu cầu cảng biển',
  PleaseARecordForEditing: 'Vui lòng chọn một bản ghi để chỉnh sửa',
  EditPortRequirementsseaPort: 'Chỉnh sửa yêu cầu cảng biển',
  PleaseARecordForDeletion: 'Vui lòng chọn bản ghi để xóa',
  WhetherDeleteTheSelectedRecords: 'Có xóa bản ghi đã chọn không?',
  Notice: 'Thông báo',
  DeletionCancelled: 'Đã hủy xóa',
  DeletionFailed: 'Xóa thất bại!',
  DisplayRulesAreRequired: 'Quy tắc hiển thị bắt buộc!',
  OperationalRequirementsAreRequired: 'Yêu cầu thao tác bắt buộc!',
  SuccessfullyAddedPortRequirements: 'Thêm yêu cầu cảng thành công',
  SuccessfullyModifiedPortRequirements: 'Sửa yêu cầu cảng thành công',
  MarksAndNumbers: 'Ký hiệu hàng hóa',
  IMDGCODEImport: 'Nhập liệu IMDG CODE',
  PleaseUploadTxtFormatFile: 'Vui lòng tải lên file định dạng txt!',
  SuccessfullyImported: 'Nhập liệu thành công',
  Items3: 'dữ liệu điều',
  DangerousGoodsList: 'Danh sách hàng nguy hiểm',
  NoteSystemReminder: 'Lưu ý: Phương thức nhắc nhở là "Nhắc nhở hệ thống", hệ thống sẽ nhắc lại trước 2 ngày khi đến hạn',
  CustomerSignedRenewal: 'Khách hàng này đã ký {0}, có thể chọn khách hàng này để gia hạn!',
  DuplicateBaseCurrencyValueExcel: 'Giá trị tiền tệ gốc \'{0}\', giá trị tiền tệ chuẩn \'{1}\' trùng lặp với dữ liệu khác trong Excel!',
  DuplicateCurrencyValue0Table: 'Giá trị tiền tệ gốc \'{0}\', giá trị tiền tệ chuẩn \'{1}\' trùng lặp với dữ liệu hiện có trong bảng!',
  DoOfThe00: 'Có xác nhận hủy bỏ hợp đồng \'{1}\' với \'{0}\' không?',
  UploadPiecesUploadFailedPieces: 'Tải lên thành công: {0}, thất bại: {1}.',
  DoWantToDelete0: 'Xác nhận xóa 【{0}】?',
  TheValueIs0Excel: 'Giá trị tiền tệ gốc \'{0}\', giá trị tiền tệ chuẩn \'{1}\' trùng lặp với dữ liệu khác trong Excel!',
  TheIs0WhichTable: 'Giá trị tiền tệ gốc \'{0}\', giá trị tiền tệ chuẩn \'{1}\' trùng lặp với dữ liệu hiện có trong bảng!',
  ChargeGroup: 'Nhóm chi phí',
  DefaultWhtRate: 'Thuế suất WHT mặc định',
  ApplicableWhtTax: 'Áp dụng thuế WHT',
  ApplicableWhtTaxTip: 'Áp dụng cho chức năng hoàn thuế WHT Thái Lan (thuế khấu trừ tại nguồn), cần phối hợp với chi nhánh để kích hoạt chức năng này.',
  ExchangeRateDecimalPlaces: 'Số thập phân tỷ giá',
  SeaAirRoutes: 'Tuyến đường biển/hàng không',
  AppliedSeaport: 'Áp dụng cảng biển',
  AppliedShippingCompany: 'Áp dụng công ty tàu biển',
  ApplicationAirport: 'Áp dụng cảng hàng không',
  AppliedAirlines: 'Hãng hàng không ứng dụng',
  VerificationItem: 'Mục kiểm tra',
  SensitiveWordExists: 'Kho từ nhạy cảm đã tồn tại',
  ClearCreditExpiration: 'Xóa kiểm soát tín dụng sau khi hết hạn',
  SubordinateCompanyPartners: 'Đối tác công ty cấp dưới',
  GpExplainTitle: 'Tiêu đề giải thích GP',
  UncheckArApMate: 'Không tham gia kiểm tra đối ứng AR/AP',
  UncheckArApMateTip: 'Sau khi tích chọn, khoản phí này sẽ không tham gia kiểm tra "phải thu bao gồm phải trả"',
  ExistCustomerVendorException: 'Nhà cung cấp khách hàng cùng tên và mã đã tồn tại, lưu thành công',
  ExistCustomerCodeExcepiton: 'Khách hàng cùng tên và mã đã tồn tại, lưu thành công',
  ExistVendorCodeException: 'Nhà cung cấp cùng tên và mã đã tồn tại, lưu thành công',
  SyncCustomerCodeExcepiton: 'Đồng bộ mã khách hàng bất thường, đã xóa mã khách hàng',
  SyncVendorCodeException: 'Đồng bộ mã nhà cung cấp bất thường, đã xóa mã nhà cung cấp',
  mailing: 'Thông tin nhận gửi',
  SyncCustomerVendorException: 'Đồng bộ mã khách hàng và nhà cung cấp bất thường, đã xóa mã khách hàng và nhà cung cấp',
  b2bWebsiteDisplayNotEmpty: 'Hiển thị website B2B không được để trống',
  IsItManualLaborCost: 'Có phải chi phí thủ công',
  FreeOfArCharge: 'Miễn thu',
  FreeOfApCharge: 'Miễn trả',
  MergeAndDisplayToDesignatedFees: 'Gộp hiển thị vào chi phí chỉ định',
  MergeAndDisplayTips: 'Giai đoạn hiện tại, thuê bao hiện tại chỉ hỗ trợ gộp hiển thị một nhóm chi phí.',
  MergeAndDisplayToDesignatedFeesTips: 'Đối với module tra cứu bán hàng và đặt chỗ từ xa, chi phí phải trả được gộp hiển thị thành tên chi phí chỉ định. Hiện tại chỉ hỗ trợ thiết lập một nhóm chi phí gộp hiển thị.',
  operationTip: 'Thao tác này sau khi xác nhận sẽ KHÔNG THỂ HOÀN TÁC!!!!',
  MscService: 'Mã Dịch vụ Msc',
  PropulsionType: 'Loại động cơ',
  AircraftModel: 'Kiểu máy ba',
  UnitLoadDevice: 'Các thiết bị đóng gói'
}
